import { useContext, createContext, useState, useEffect, useCallback } from "react";

const SealContext = createContext();

export default function SealProvider({ children }) {
  const [state, setState] = useState(null);

  const refresh = useCallback(() => {
    getPodStatus().then(setState).catch(console.error);
  }, []);

  // fetch status on mount
  useEffect(() => {
    refresh();
  }, [refresh]);

  // poll status every 5 seconds — interval runs unconditionally so a failed
  // fetch retries instead of leaving the app stuck on the loading spinner
  useEffect(() => {
    const interval = setInterval(refresh, 5000);
    return () => clearInterval(interval);
  }, [refresh]);

  return (
    <SealContext.Provider value={{ state, refresh }}>
      {children}
    </SealContext.Provider>
  );
}

async function getPodStatus() {
  const response = await fetch("/api/v1/bggw/status", {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) {
    throw new Error("Failed to fetch status");
  }
  return await response.json();
}

export const GetSealStatus = () => {
  return useContext(SealContext);
};
